/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { AddAnswerRequest } from "../model"
// @ts-ignore
import type { CreateEntrepreneurRequest } from "../model"
// @ts-ignore
import type { Entrepreneur } from "../model"
// @ts-ignore
import type { EntrepreneurQuestionResult } from "../model"
// @ts-ignore
import type { SaveHouseHoldRequest } from "../model"
// @ts-ignore
import type { UpdateEntrepreneurRequest } from "../model"
/**
 * EntrepreneurResourceApi - axios parameter creator
 */
export const EntrepreneurResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Add or update an answer to an entrepreneur\'s question
     * @param {string} entrepreneurId
     * @param {AddAnswerRequest} addAnswerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAnswer: async (
      entrepreneurId: string,
      addAnswerRequest: AddAnswerRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'entrepreneurId' is not null or undefined
      assertParamExists("addAnswer", "entrepreneurId", entrepreneurId)
      // verify required parameter 'addAnswerRequest' is not null or undefined
      assertParamExists("addAnswer", "addAnswerRequest", addAnswerRequest)
      const localVarPath = `/entrepreneurs/{entrepreneurId}/answer`.replace(
        "{entrepreneurId}",
        encodeURIComponent(String(entrepreneurId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addAnswerRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Create entrepreneur
     * @param {string} noteId
     * @param {CreateEntrepreneurRequest} createEntrepreneurRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEntrepreneur: async (
      noteId: string,
      createEntrepreneurRequest: CreateEntrepreneurRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists("createEntrepreneur", "noteId", noteId)
      // verify required parameter 'createEntrepreneurRequest' is not null or undefined
      assertParamExists(
        "createEntrepreneur",
        "createEntrepreneurRequest",
        createEntrepreneurRequest
      )
      const localVarPath = `/entrepreneurs/projects/{noteId}`.replace(
        "{noteId}",
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createEntrepreneurRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Delete an entrepreneur by muffin id
     * @param {string} idMuffin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEntrepreneur: async (
      idMuffin: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'idMuffin' is not null or undefined
      assertParamExists("deleteEntrepreneur", "idMuffin", idMuffin)
      const localVarPath = `/entrepreneurs/{idMuffin}`.replace(
        "{idMuffin}",
        encodeURIComponent(String(idMuffin))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Check if a project has an entrepreneur account
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasEntrepreneurAccount: async (
      projectId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("hasEntrepreneurAccount", "projectId", projectId)
      const localVarPath = `/entrepreneurs/projects/{projectId}/hasEntrepreneurAccount`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update entrepreneur\'s household infos
     * @param {string} entrepreneurId
     * @param {SaveHouseHoldRequest} saveHouseHoldRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveHouseHold: async (
      entrepreneurId: string,
      saveHouseHoldRequest: SaveHouseHoldRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'entrepreneurId' is not null or undefined
      assertParamExists("saveHouseHold", "entrepreneurId", entrepreneurId)
      // verify required parameter 'saveHouseHoldRequest' is not null or undefined
      assertParamExists("saveHouseHold", "saveHouseHoldRequest", saveHouseHoldRequest)
      const localVarPath = `/entrepreneurs/{entrepreneurId}/household`.replace(
        "{entrepreneurId}",
        encodeURIComponent(String(entrepreneurId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        saveHouseHoldRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update entrepreneur
     * @param {string} entrepreneurId
     * @param {UpdateEntrepreneurRequest} updateEntrepreneurRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEntrepreneur: async (
      entrepreneurId: string,
      updateEntrepreneurRequest: UpdateEntrepreneurRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'entrepreneurId' is not null or undefined
      assertParamExists("updateEntrepreneur", "entrepreneurId", entrepreneurId)
      // verify required parameter 'updateEntrepreneurRequest' is not null or undefined
      assertParamExists(
        "updateEntrepreneur",
        "updateEntrepreneurRequest",
        updateEntrepreneurRequest
      )
      const localVarPath = `/entrepreneurs/{entrepreneurId}`.replace(
        "{entrepreneurId}",
        encodeURIComponent(String(entrepreneurId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateEntrepreneurRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * EntrepreneurResourceApi - functional programming interface
 */
export const EntrepreneurResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EntrepreneurResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Add or update an answer to an entrepreneur\'s question
     * @param {string} entrepreneurId
     * @param {AddAnswerRequest} addAnswerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addAnswer(
      entrepreneurId: string,
      addAnswerRequest: AddAnswerRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntrepreneurQuestionResult>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addAnswer(
        entrepreneurId,
        addAnswerRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["EntrepreneurResourceApi.addAnswer"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create entrepreneur
     * @param {string} noteId
     * @param {CreateEntrepreneurRequest} createEntrepreneurRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEntrepreneur(
      noteId: string,
      createEntrepreneurRequest: CreateEntrepreneurRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entrepreneur>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createEntrepreneur(
        noteId,
        createEntrepreneurRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["EntrepreneurResourceApi.createEntrepreneur"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete an entrepreneur by muffin id
     * @param {string} idMuffin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteEntrepreneur(
      idMuffin: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntrepreneur(
        idMuffin,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["EntrepreneurResourceApi.deleteEntrepreneur"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Check if a project has an entrepreneur account
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hasEntrepreneurAccount(
      projectId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.hasEntrepreneurAccount(
        projectId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["EntrepreneurResourceApi.hasEntrepreneurAccount"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update entrepreneur\'s household infos
     * @param {string} entrepreneurId
     * @param {SaveHouseHoldRequest} saveHouseHoldRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async saveHouseHold(
      entrepreneurId: string,
      saveHouseHoldRequest: SaveHouseHoldRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entrepreneur>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.saveHouseHold(
        entrepreneurId,
        saveHouseHoldRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["EntrepreneurResourceApi.saveHouseHold"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update entrepreneur
     * @param {string} entrepreneurId
     * @param {UpdateEntrepreneurRequest} updateEntrepreneurRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEntrepreneur(
      entrepreneurId: string,
      updateEntrepreneurRequest: UpdateEntrepreneurRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Entrepreneur>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEntrepreneur(
        entrepreneurId,
        updateEntrepreneurRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["EntrepreneurResourceApi.updateEntrepreneur"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * EntrepreneurResourceApi - factory interface
 */
export const EntrepreneurResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EntrepreneurResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Add or update an answer to an entrepreneur\'s question
     * @param {EntrepreneurResourceApiAddAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addAnswer(
      requestParameters: EntrepreneurResourceApiAddAnswerRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EntrepreneurQuestionResult> {
      return localVarFp
        .addAnswer(requestParameters.entrepreneurId, requestParameters.addAnswerRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Create entrepreneur
     * @param {EntrepreneurResourceApiCreateEntrepreneurRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEntrepreneur(
      requestParameters: EntrepreneurResourceApiCreateEntrepreneurRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Entrepreneur> {
      return localVarFp
        .createEntrepreneur(
          requestParameters.noteId,
          requestParameters.createEntrepreneurRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Delete an entrepreneur by muffin id
     * @param {EntrepreneurResourceApiDeleteEntrepreneurRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEntrepreneur(
      requestParameters: EntrepreneurResourceApiDeleteEntrepreneurRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .deleteEntrepreneur(requestParameters.idMuffin, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Check if a project has an entrepreneur account
     * @param {EntrepreneurResourceApiHasEntrepreneurAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasEntrepreneurAccount(
      requestParameters: EntrepreneurResourceApiHasEntrepreneurAccountRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .hasEntrepreneurAccount(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update entrepreneur\'s household infos
     * @param {EntrepreneurResourceApiSaveHouseHoldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveHouseHold(
      requestParameters: EntrepreneurResourceApiSaveHouseHoldRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Entrepreneur> {
      return localVarFp
        .saveHouseHold(
          requestParameters.entrepreneurId,
          requestParameters.saveHouseHoldRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update entrepreneur
     * @param {EntrepreneurResourceApiUpdateEntrepreneurRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEntrepreneur(
      requestParameters: EntrepreneurResourceApiUpdateEntrepreneurRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Entrepreneur> {
      return localVarFp
        .updateEntrepreneur(
          requestParameters.entrepreneurId,
          requestParameters.updateEntrepreneurRequest,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for addAnswer operation in EntrepreneurResourceApi.
 */
export interface EntrepreneurResourceApiAddAnswerRequest {
  readonly entrepreneurId: string

  readonly addAnswerRequest: AddAnswerRequest
}

/**
 * Request parameters for createEntrepreneur operation in EntrepreneurResourceApi.
 */
export interface EntrepreneurResourceApiCreateEntrepreneurRequest {
  readonly noteId: string

  readonly createEntrepreneurRequest: CreateEntrepreneurRequest
}

/**
 * Request parameters for deleteEntrepreneur operation in EntrepreneurResourceApi.
 */
export interface EntrepreneurResourceApiDeleteEntrepreneurRequest {
  readonly idMuffin: string
}

/**
 * Request parameters for hasEntrepreneurAccount operation in EntrepreneurResourceApi.
 */
export interface EntrepreneurResourceApiHasEntrepreneurAccountRequest {
  readonly projectId: string
}

/**
 * Request parameters for saveHouseHold operation in EntrepreneurResourceApi.
 */
export interface EntrepreneurResourceApiSaveHouseHoldRequest {
  readonly entrepreneurId: string

  readonly saveHouseHoldRequest: SaveHouseHoldRequest
}

/**
 * Request parameters for updateEntrepreneur operation in EntrepreneurResourceApi.
 */
export interface EntrepreneurResourceApiUpdateEntrepreneurRequest {
  readonly entrepreneurId: string

  readonly updateEntrepreneurRequest: UpdateEntrepreneurRequest
}

/**
 * EntrepreneurResourceApi - object-oriented interface
 */
export class EntrepreneurResourceApi extends BaseAPI {
  /**
   *
   * @summary Add or update an answer to an entrepreneur\'s question
   * @param {EntrepreneurResourceApiAddAnswerRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public addAnswer(
    requestParameters: EntrepreneurResourceApiAddAnswerRequest,
    options?: RawAxiosRequestConfig
  ) {
    return EntrepreneurResourceApiFp(this.configuration)
      .addAnswer(requestParameters.entrepreneurId, requestParameters.addAnswerRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create entrepreneur
   * @param {EntrepreneurResourceApiCreateEntrepreneurRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createEntrepreneur(
    requestParameters: EntrepreneurResourceApiCreateEntrepreneurRequest,
    options?: RawAxiosRequestConfig
  ) {
    return EntrepreneurResourceApiFp(this.configuration)
      .createEntrepreneur(
        requestParameters.noteId,
        requestParameters.createEntrepreneurRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete an entrepreneur by muffin id
   * @param {EntrepreneurResourceApiDeleteEntrepreneurRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteEntrepreneur(
    requestParameters: EntrepreneurResourceApiDeleteEntrepreneurRequest,
    options?: RawAxiosRequestConfig
  ) {
    return EntrepreneurResourceApiFp(this.configuration)
      .deleteEntrepreneur(requestParameters.idMuffin, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Check if a project has an entrepreneur account
   * @param {EntrepreneurResourceApiHasEntrepreneurAccountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public hasEntrepreneurAccount(
    requestParameters: EntrepreneurResourceApiHasEntrepreneurAccountRequest,
    options?: RawAxiosRequestConfig
  ) {
    return EntrepreneurResourceApiFp(this.configuration)
      .hasEntrepreneurAccount(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update entrepreneur\'s household infos
   * @param {EntrepreneurResourceApiSaveHouseHoldRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public saveHouseHold(
    requestParameters: EntrepreneurResourceApiSaveHouseHoldRequest,
    options?: RawAxiosRequestConfig
  ) {
    return EntrepreneurResourceApiFp(this.configuration)
      .saveHouseHold(
        requestParameters.entrepreneurId,
        requestParameters.saveHouseHoldRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update entrepreneur
   * @param {EntrepreneurResourceApiUpdateEntrepreneurRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateEntrepreneur(
    requestParameters: EntrepreneurResourceApiUpdateEntrepreneurRequest,
    options?: RawAxiosRequestConfig
  ) {
    return EntrepreneurResourceApiFp(this.configuration)
      .updateEntrepreneur(
        requestParameters.entrepreneurId,
        requestParameters.updateEntrepreneurRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
